import { useState } from 'react';

import { Box } from '@chakra-ui/react';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@mesh.ai/rabbit';
import { useDispatch } from 'react-redux';

import { BottomDrawer, DrawerBody, DrawerContent, DrawerFooter, DrawerHeader } from 'uiToolkitV1/BottomDrawer';
import { Button } from 'uiToolkitV1/Button';
import { TextBodyMedium } from 'uiToolkitV1/Typography';

import { CreateGuidelineTable } from './CreateGuidelineTable';
import {
  useCompensationDrawersState,
  setIsCreateGuidelineDrawerOpen,
  setModifiedCreateGuidelineRows,
} from './slice/compensationDrawersSlice';

// Mock data for dropdowns
const guidelineOptions = [
  { value: 'no_segmentation', label: 'No segmentation' },
  { value: 'performance_label', label: 'Performance label' },
  { value: 'performance_rating', label: 'Performance rating' },
];

export const CreateGuidelineDrawer = () => {
  const { isCreateGuidelineDrawerOpen } = useCompensationDrawersState();
  const dispatch = useDispatch();

  const [selectedGuideline, setSelectedGuideline] = useState(guidelineOptions[1]);

  const onClose = () => {
    dispatch(setIsCreateGuidelineDrawerOpen(false));
    dispatch(setModifiedCreateGuidelineRows([]));
  };

  const onSave = () => {
    // Add save functionality here
    onClose();
  };

  return (
    <BottomDrawer isOpen={isCreateGuidelineDrawerOpen} onClose={onClose} placement="bottom">
      <DrawerContent width="auto" ml="40px !important" maxH="calc(100vh - 40px)">
        <DrawerHeader onClose={onClose}>
          <Box padding="10px 10px" display="flex" justifyContent="space-between" alignItems="center">
            <Box display="flex" alignItems="center" gap="8px">
              <TextBodyMedium bold whiteSpace="nowrap">
                Create new guideline based on
              </TextBodyMedium>
              <Box>
                <Select
                  value={selectedGuideline.value}
                  onValueChange={(value) => {
                    const selectedOption = guidelineOptions.find((option) => option.value === value);
                    if (selectedOption) {
                      setSelectedGuideline(selectedOption);
                    }
                  }}
                >
                  <SelectTrigger>
                    <SelectValue placeholder="Select guideline" />
                  </SelectTrigger>
                  <SelectContent style={{ width: '200px' }}>
                    {guidelineOptions.map((option) => (
                      <SelectItem key={option.value} value={option.value}>
                        {option.label}
                      </SelectItem>
                    ))}
                  </SelectContent>
                </Select>
              </Box>
            </Box>
          </Box>
        </DrawerHeader>
        <DrawerBody>
          <Box
            borderWidth="4px"
            borderStyle="solid"
            borderColor="neutral.EBEFF3"
            padding="8px 8px 12px 8px"
            margin="4px 4px 8px 4px"
            borderRadius="8px"
            height="calc(100% - 12px)"
          >
            <CreateGuidelineTable gridStatePersistenceKey="create-guideline-table" />
          </Box>
        </DrawerBody>
        <DrawerFooter display="flex" justifyContent="space-between">
          <Button variant="outlined" mr={4} onClick={onClose}>
            Cancel
          </Button>
          <Button variant="filled" colorScheme="blue" onClick={onSave}>
            Save
          </Button>
        </DrawerFooter>
      </DrawerContent>
    </BottomDrawer>
  );
};
